<script lang="ts" setup>
  interface Props {
    freeDeliveryRemaining: number | null | string,
  }

  defineProps<Props>();
</script>
<template>
  <div v-if="freeDeliveryRemaining" class="free-delivery-remaining">
    <div class="free-delivery-remaining__icon-wrapper">
      <SfIconTruck aria-hidden="true" />
    </div>
    <p>
      {{ $t('SHOP.COMMON.LABEL.FREE_DELIVERY_REMAINING') }}
      <SfMoney :value="freeDeliveryRemaining" />
    </p>
  </div>
</template>
<style lang="scss" scoped>
  .free-delivery-remaining {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
    color: var(--sf-list-card-color);
    background: var(--sf-tile-background);
    border-radius: var(--sf-tile-border-radius);
    border-inline: var(--sf-tile-border-inline);
    border-block: var(--sf-tile-border-block);

    .money {
      font-weight: var(--font-weight-semi);
    }

    &__icon-wrapper {
      display: grid;
      place-items: center;
      font-size: 1rem;
      color: var(--foreground-on-primary-bg);
      padding: 0.375rem;
      background: var(--primary-background);
      border-radius: var(--border-radius);
    }
  }
</style>